// extracted by mini-css-extract-plugin
export var skipAnimation = "_3n-0";